// removed by extract-text-webpack-plugin
module.exports = {"hotel-details":"HotelDetails_hotel-details---sb","hotelDetails":"HotelDetails_hotel-details---sb","rtl":"HotelDetails_rtl---sb","hotel-name":"HotelDetails_hotel-name---sb","hotelName":"HotelDetails_hotel-name---sb","description":"HotelDetails_description---sb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HotelDetails/styles.less
// module id = 1616
// module chunks = 0